import { LogOut } from 'lucide-react'
import { Link, Outlet, useNavigate } from 'react-router'

import { useLogout, useMe } from '@/auth/queries'
import { ModeToggle } from '@/components/mode-toggle'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export function AppLayout() {
  const me = useMe()
  const logout = useLogout()
  const navigate = useNavigate()
  const account = me.data

  const onSignOut = (): void => {
    logout.mutate({}, { onSettled: () => navigate('/login', { replace: true }) })
  }

  return (
    <div className="bg-background min-h-screen">
      <header className="border-b pl-[max(1rem,env(safe-area-inset-left))] pr-[max(1rem,env(safe-area-inset-right))] pt-[env(safe-area-inset-top)]">
        <div className="flex h-14 items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/" className="font-semibold">
              TradVal Monitor
            </Link>
            {account?.role === 'admin' && (
              <nav className="text-muted-foreground flex gap-3 text-sm">
                <Link to="/admin/families" className="hover:text-foreground">
                  Families
                </Link>
                <Link to="/admin/agent-releases" className="hover:text-foreground">
                  Releases
                </Link>
                <Link to="/admin/settings" className="hover:text-foreground">
                  Settings
                </Link>
              </nav>
            )}
          </div>
          <div className="flex items-center gap-2">
            <ModeToggle />
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm">
                  {account?.name ?? account?.email ?? 'Account'}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                {account && (
                  <>
                    <DropdownMenuLabel className="font-normal">
                      <div className="flex flex-col space-y-0.5">
                        <span className="text-sm font-medium">{account.name}</span>
                        <span className="text-muted-foreground text-xs">{account.email}</span>
                      </div>
                    </DropdownMenuLabel>
                    <DropdownMenuSeparator />
                  </>
                )}
                <DropdownMenuItem onSelect={onSignOut} disabled={logout.isPending}>
                  <LogOut className="mr-2 h-4 w-4" />
                  Sign out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </header>
      <main className="p-4 pb-[max(1rem,env(safe-area-inset-bottom))] pl-[max(1rem,env(safe-area-inset-left))] pr-[max(1rem,env(safe-area-inset-right))]">
        <Outlet />
      </main>
    </div>
  )
}
